import moment from 'moment'
import {database} from '../main'
export const getReportsMixin = {
  data () {
    return {
      moment,
      users: [],
      loading: false,
      contracts: [],
      programs: [],
      managers: [],
      tableData: [],
      filteredData: [],
      contractsOn: false,
      programsOn: false,
      search: '',
      contractFilters: [],
      programFilters: [],
      date1: null,
      date2: null,
      userSelect: [],
      managerSelect: []
    };
  },
  created () {
    this.fetchData()
  },
  methods: {
    async fetchData () {
      console.log(this)
      this.loading = true
      let reports
      if (this.userId) {
        reports = await database.ref('/reports').orderByChild('user').equalTo(this.userId).once('value')
      } else if (this.managerId) {
        reports = await database.ref('/reports').orderByChild('managerId').equalTo(this.managerId).once('value')
      } else {
        reports = await database.ref('/reports').once('value')
      }
      reports = reports.val() || []
      let contracts = await database.ref('/contracts').once('value')
      contracts = contracts.val()
      this.contracts = Object.keys(contracts).map(key => ({
        name: contracts[key].name,
        id: key
      }))
      let programs = await database.ref('/programs').once('value')
      programs = programs.val()
      this.programs = Object.keys(programs).map(key => ({
        name: programs[key].name,
        id: key
      }))
      let users
      if (this.managerId) {
        let team = await database.ref('/teams').orderByChild('managerId').equalTo(this.managerId).once('value')
        team = team.val()
        const teamId = Object.keys(team)[0]
        // users = await database.ref('/users').once('value')
        users = await database.ref('/users').orderByChild('teamId').equalTo(teamId).once('value')
      } else {
        users = await database.ref('/users').once('value')
      }
      users = users.val()
      this.users = Object.keys(users).map(key => ({
        name: users[key].firstName + ' ' + users[key].lastName,
        id: key,
        role: users[key].role
      }))
      this.managers = this.users.filter(user => user.role === 'manager')
      const reportArray = Object.keys(reports).map(key => ({
        reportId: key,
        activities: reports[key].activities,
        improvements: reports[key].improvements,
        feedback: reports[key].feedback,
        contractId: reports[key].contract,
        userId: reports[key].user,
        managerId: reports[key].managerId || null,
        programs: reports[key].programs,
        month: moment(reports[key].month),
        status: reports[key].status
      }))
      const results = await Promise.all(reportArray.map(async (report) => {
          let contract = await database.ref(`/contracts/${report.contractId}`).once('value')
          report.contractName = contract.val().name
          let user = await database.ref(`/users/${report.userId}`).once('value')
          report.name = `${user.val().firstName} ${user.val().lastName}`
          let manager
          if (report.managerId) {
            manager = await database.ref(`/users/${report.managerId}`).once('value')
            report.manager = `${manager.val().firstName} ${manager.val().lastName}`
          }
          if (report.programs) {
            const programs = await Promise.all(report.programs.map(async (program) => {
                let programData = await database.ref(`/programs/${program}`).once('value')
                return {
                   id: program,
                   name: programData.val().name
                  }
              }))
            report.programs = programs
          } else {
            report.programs = []
          }
          return report
        }))

      this.tableData = results
      this.filteredData = results
      this.loading = false
    },
    filter () {
      let reports = [...this.tableData]

      /* reports = this.filterManagers(reports)
      reports = this.filterDates(reports)
      reports = this.filterUsers(reports)
      reports = this.searchReports(reports)
      reports = this.filterPrograms(reports)
      reports = this.filterContracts(reports)
      this.filteredData = reports */
      this.filteredData = this.filterManagers(this.filterDates(this.filterUsers(this.searchReports(this.filterPrograms(this.filterContracts(reports))))))
    },
    filterDates (reports) {
      const range = moment.range(this.date1, this.date2);
      return reports.filter(report => range.contains(report.month))
    },
    searchReports (reports) {
      if (this.search.length) {
        const regex = new RegExp(this.search, 'i');
        return reports.filter(report => report.activities.match(regex) || report.improvements.match(regex) || report.feedback.match(regex))
      }
      return reports
    },
    filterContracts (reports) {
      const {contractFilters} = this
      return contractFilters.length ? reports.filter(report => contractFilters.includes(report.contractName)) : reports
    },
    filterUsers (reports) {
      const {userSelect} = this
      return userSelect.length ? reports.filter(report => userSelect.includes(report.name)) : reports
    },
    filterManagers (reports) {
      const {managerSelect} = this
      return managerSelect.length ? reports.filter(report => managerSelect.includes(report.manager)) : reports
    },
    filterPrograms (reports) {
      const {programFilters} = this
      return programFilters.length ? reports.filter(report => {
          let present = false;
          report.programs.forEach(program => {
            if (programFilters.includes(program.name)) present = true
            })
          return present
        }) : reports
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/getReportsMixin.js